export const FETCH_HEATMAP_REQUEST = "FETCH_HEATMAP_REQUEST";
export const FETCH_HEATMAP_SUCCESS = "FETCH_HEATMAP_SUCCESS";
export const FETCH_HEATMAP_FAILURE = "FETCH_HEATMAP_FAILURE";
